import { Button, Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdminUsers } from "../../Redux/FAQSlice";
import AddUserpopup from "./AddUserpopup";

const ColorButton = styled(Button)(({ theme }) => ({
 //  color: theme.palette.getContrastText(purple[500]),
 width: "200px",
 backgroundColor: "#460073",
 color: "white",
 border: "solid 1px grey",
 textTransform: "none",
 padding: "6px 30px",
 "&:hover": { backgroundColor: "#460073", color: "white" },
 "&:active": {
  backgroundColor: "#460073",
  color: "white",
 },
}));
function Admin() {
 const dispatch = useDispatch();
 const [open, setOpen] = React.useState(false);

 const ref = useRef();
 useEffect(() => {
  dispatch(fetchAdminUsers());
 }, []);
 const data = useSelector((state) => state.faq.adminList);

 const [page, setPage] = React.useState(0);
 const [rowsPerPage, setRowsPerPage] = React.useState(10);

 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };

 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(+event.target.value);
  setPage(0);
 };
 return (
  <>
   <Stack sx={{ justifyContent: "center", alignItems: "center", padding: "20px" }}>
    <Stack justifyContent={"flex-end"} sx={{ width: "100%" }}>
     <ColorButton
      onClick={() => {
       setOpen(true);
      }}
     >
      Add Admin User
     </ColorButton>
    </Stack>

    <Paper sx={{ width: "50%", overflow: "hidden", margin: "20px 0px 20px 0px" }}>
     <TableContainer sx={{ maxHeight: 440 }}>
      <Table stickyHeader aria-label="sticky table">
       <TableHead>
        <TableRow>
         <TableCell
          align={"center"}
          style={{
           minWidth: "100%",
           background: "#460073",
           color: "white",
           fontSize: "16px",
          }}
         >
          Enterprise ID
         </TableCell>
        </TableRow>
       </TableHead>
       <TableBody>
        {data
         .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
         .map((row, i) => {
          return (
           <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
            <TableCell key={i} align={"center"}>
             {row.enterpriseID}
            </TableCell>
           </TableRow>
          );
         })}
       </TableBody>
      </Table>
     </TableContainer>
     <TablePagination
      rowsPerPageOptions={[10, 25, 100]}
      component="div"
      count={data.length}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
     />
    </Paper>
   </Stack>
   <AddUserpopup open={open} setOpen={setOpen} />
  </>
 );
}

export default Admin;
